import { BillLineDebitV2, BillLineItemV2Kind } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const lineItemDebitFinancingMock = new MockFactory<BillLineDebitV2>({
  id: 'line_item_id_02',
  amount_cents: 1002,
  reference_date: '2023-12-01T00:00:00Z',
  payer_id: 'player_id_01',
  kind: BillLineItemV2Kind.DebtFinancing,
  metadata: {
    financing_debt_id: 'financing_debt_id_1',
    financing_id: 'financing_id_1',
    base_debt_id: 'base_debt_id-99',
    total_amount_cents: 20000,
    paid_amount_cents: 0,
    created_at: '2023-12-01T00:00:00Z',
    activated_at: '2022-04-10T00:00:00Z',
    due_at: '2023-12-08T02:59:59Z',
  },
})
